import { Remove } from '@mui/icons-material';
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { deleteUserBusinessPortfolio, deleteUsersRelations } from 'lib/api';
import CustomButton from 'lib/designSystem/Button';
import DialogTitle from 'lib/designSystem/Title/DialogTitle';
import { errorHandler } from 'lib/functions/errors';
import { showAlert } from 'lib/functions/utils';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Executive } from './ExecutiveRow';

interface DeleteExecutiveDialogProps {
  open: boolean;
  onClose: () => void;
  executive: Executive | null;
  type: 'commercial' | 'collection' | null;
  businessIdentifier: string;
  onSuccess: () => Promise<void>;
}

const DeleteExecutiveDialog: React.FC<DeleteExecutiveDialogProps> = ({
  open,
  onClose,
  executive,
  type,
  businessIdentifier,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const [deleting, setDeleting] = useState(false);

  const handleDeleteConfirm = async () => {
    if (!executive || !type) return;

    try {
      setDeleting(true);

      if (type === 'commercial') {
        await deleteUsersRelations(dispatch, {
          id: Number(executive.id),
          businessId: businessIdentifier,
        });
      } else {
        await deleteUserBusinessPortfolio(dispatch, Number(executive.id), {
          businessIdentifier: businessIdentifier,
        });
      }

      await onSuccess();
      showAlert(dispatch, 'success', 'Ejecutivo desasignado correctamente');
      onClose();
    } catch (error) {
      errorHandler(dispatch, error);
    } finally {
      setDeleting(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle
        onClose={onClose}
        title="Desasociar ejecutivo"
        icon={<Remove color="error" />}
        color="error"
      />
      <DialogContent>
        <Typography>
          ¿Estás seguro de que deseas desasociar a{' '}
          <Typography component="span" fontWeight="bold">
            {executive?.name}
          </Typography>{' '}
          como ejecutivo {type === 'commercial' ? 'comercial' : 'de cobranza'}?
        </Typography>
      </DialogContent>
      <DialogActions>
        <CustomButton
          onClick={handleCancel}
          color="secondary"
          disabled={deleting}
        >
          Cancelar
        </CustomButton>
        <CustomButton
          onClick={handleDeleteConfirm}
          color="error"
          disabled={deleting}
          loading={deleting}
        >
          Desasociar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteExecutiveDialog;
